// extracted by mini-css-extract-plugin
module.exports = {"CarouselSlickVertical":"CarouselSlick_CarouselSlickVertical__5Ln7U"};